/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings
 */
export interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings {
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'detectedDpi'?: GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'calculatedDpi'?: GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'colorGradation'?: GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'heightMillis'?: GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'widthMillis'?: GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum;
}

export const GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum = typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum[keyof typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum];
export const GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum = typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum[keyof typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum];
export const GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum = typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum[keyof typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum];
export const GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum = typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum[keyof typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum];
export const GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum = typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum[keyof typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum];


